var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1626 20.6626L15.6626 33.1626C15.4848 33.3282 15.2498 33.4183 15.0069 33.414C14.764 33.4097 14.5323 33.3113 14.3605 33.1396C14.1888 32.9678 14.0904 32.7361 14.0861 32.4932C14.0818 32.2503 14.172 32.0153 14.3376 31.8376L26.1735 20.0001L14.3376 8.16255C14.172 7.98483 14.0818 7.74978 14.0861 7.5069C14.0904 7.26402 14.1888 7.03229 14.3605 6.86052C14.5323 6.68876 14.764 6.59037 15.0069 6.58608C15.2498 6.5818 15.4848 6.67195 15.6626 6.83755L28.1626 19.3376C28.3381 19.5133 28.4367 19.7516 28.4367 20.0001C28.4367 20.2485 28.3381 20.4868 28.1626 20.6626Z",
    fill: "#E1E7ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/CaretRight.c9eed983665ef761611e6bffc8a0ecd0.svg";
export { ForwardRef as ReactComponent };